import React from 'react';
import { Pressable, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Text } from '~/components/core';
import { FONT_SIZE_XXS } from '~/constants';
import { isDesktop, scaleSize } from '~/constants/scale';
import { useAIStrategyEnabled, useAppDispatch, useStyles } from '~/hooks';
import { linkTo } from '~/navigation';
import paths from '~/navigation/paths';
import { openStrategyOnDesktop } from '~/state/reducers/desktopSlice';
import { Theme } from '~/theme';

type Props = {
    strategyId?: string | null;
    rowStyle?: StyleProp<ViewStyle>;
};

// Renders nothing without a strategy, so callers can drop it in unconditionally.
export default function StrategyLinkRow({ strategyId, rowStyle }: Props) {
    const styles = useStyles(stylesGenerator);
    const aiStrategyEnabled = useAIStrategyEnabled();
    const dispatch = useAppDispatch();

    if (!strategyId || !aiStrategyEnabled) {
        return null;
    }

    const onPress = () => {
        if (isDesktop()) {
            dispatch(openStrategyOnDesktop(strategyId));
            return;
        }
        linkTo(paths.aiStrategyDetails.replace(':strategyId', strategyId));
    };

    return (
        <View style={[styles.row, rowStyle]}>
            <Pressable onPress={onPress} hitSlop={scaleSize(6)}>
                <Text fontType="LATO_BOLD" style={styles.link}>
                    ai-strategy-view-strategy
                </Text>
            </Pressable>
        </View>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        row: {
            width: '100%',
            paddingVertical: scaleSize(4),
            paddingLeft: scaleSize(10),
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
        },
        link: {
            fontSize: FONT_SIZE_XXS,
            letterSpacing: 0,
            color: theme.button,
            textDecorationLine: 'underline',
        },
    });
